"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Tasked as MIDI helper functions
// handle MTC/MTC data
// Parse MTC/MMC data into timecode
// Send MTC/MMC data through MIDI
const types_1 = require("./types");
var DEBUG_MIDI = false;
// Read and interpret MIDI Devices output
class MIDIReceiver {
    constructor(_newMIDIActionCallback) {
        this.totalMessagesReceived = 0;
        this.lastDataReceived = new Uint8Array(0);
        this.MTCBinaryDataArray = [0, 0, 0, 0, 0, 0, 0, 0];
        this.mtcTimeout = 0;
        this.skipGoToUntil = 0;
        this.currentTimecode = (0, types_1.newTimecode)(0, 0, 0, 0, 30);
        this.currentFramerate = 30;
        this.isPlaying = false;
        this.isRecording = false;
        this.debugLog = false;
        this.onMIDIActionCallback = _newMIDIActionCallback;
    }
    setCurrentFramerate(framerate) {
        this.currentFramerate = framerate;
    }
    // HANDLE MIDI DATA
    // @ts-ignore
    HandleRawMIDIData(message) {
        this.totalMessagesReceived += 1;
        const data = message.data;
        // Sometimes MIDI Sends the same message twice, this avoids that
        if (JSON.stringify(data) == JSON.stringify(this.lastDataReceived))
            return;
        // its a ping, ignore it otherwise we will receive duplicates
        if (data.length == 3 && data[0] == 0x90 && data[1] == 0x0 && data[2] == 0x0) {
            return;
        }
        this.lastDataReceived = data;
        switch (data[0]) {
            case 0xf0:
                this.HandleMMCMessage(data);
                break;
            case 0xf1:
                this.HandleMTCMessage(data);
                break;
            case 0x90:
            case 0xb0:
                this.HandleHUIMessage(data);
                break;
            default:
                if (DEBUG_MIDI)
                    console.log("UNKNOWN MIDI MESSAGE", data);
        }
    }
    // experimental, trying to detect if recording is "on"
    //  sample data we will receive
    //   [176, 12, 14, 176, 44, 5, 176]
    //   [144, 0, 0, 176, 12, 14, 176, 44, 69, 176]
    // [176, 12, 14, 176, 44, 5, 176, 12, 15, 176, 44, 2, 176, 12, 13, 176, 44, 2, 247]
    HandleHUIMessage(data) {
        // If data contains [176, 44, 69 176] anywhere along the array then:
        //   turn on Recording and send a REC_ON
        if (data.includes(44) && data.includes(69) && this.isRecording == false) {
            this.isRecording = true;
            this.onMIDIActionCallback("REC_ON", this.currentTimecode);
            return;
        }
        // If data then contains [176, 44, 2, 176] and recording = on:
        //   turn off recording and send a REC_OFF
        if (data.includes(44) && data.includes(2) && this.isRecording == true) {
            this.isRecording = false;
            this.onMIDIActionCallback("REC_OFF", this.currentTimecode);
            return;
        }
    }
    // MIDI sends 8 packets (quarter frame) for a full timecode
    // in the following order
    // 0: LSB frame
    // 1: MSB frame
    // 2: LSB seconds
    // 3: MSB seconds
    // 4: LSB minutes
    // 5: MSB minutes
    // 6: LSB hours
    // 7: MSB hours
    // so what we need to do is first fill the data array
    // then we we have the full timecode we can parse it
    // each quarterpacket is consisted of an index and the data
    // 4 first bits for index and last 4 bits for data
    HandleMTCMessage(data) {
        const index = data[1] >> 4;
        // deletes type data from the message
        // 0x0F is 0000 1111 which means that any 0 would be converted to 0 by the & operation
        const dataWithoutIndex = data[1] & 0x0f;
        this.MTCBinaryDataArray[index] = dataWithoutIndex;
        if (index == 7) {
            // check if all the data is there
            // if so parse it
            for (let i = 0; i < 8; i++) {
                if (this.MTCBinaryDataArray[i] == undefined) {
                    return;
                }
            }
            const tc = this.ParseMTCMessage(this.MTCBinaryDataArray);
            if (this.isPlaying == false) {
                this.onMIDIActionCallback("Play", tc);
                this.isPlaying = true;
            }
            else {
            }
            this.onMIDIActionCallback("MTC", tc);
            let diff = Math.abs(this.TimecodeDiffInFrames(tc, this.currentTimecode));
            if (diff > 10) {
                // we cant loop as MTC doesnt support it, maybe later do something else
            }
            else {
                if (this.debugLog)
                    console.log(diff, tc);
            }
            this.currentTimecode = tc;
            // set a timeout of not receiving new messages to announce it has paused
            if (this.mtcTimeout != 0) {
                window.clearTimeout(this.mtcTimeout);
            }
            this.mtcTimeout = window.setTimeout(() => {
                this.onMIDIActionCallback("Stop", tc);
                // Note that access to this variable can cause a race condition
                this.isPlaying = false;
            }, 500);
        }
    }
    TimecodeDiffInFrames(tc1, tc2) {
        const frames1 = tc1.hours * 3600 * tc1.framerate +
            tc1.minutes * 60 * tc1.framerate +
            tc1.seconds * tc1.framerate +
            tc1.frames;
        const frames2 = tc2.hours * 3600 * tc2.framerate +
            tc2.minutes * 60 * tc2.framerate +
            tc2.seconds * tc2.framerate +
            tc2.frames;
        return frames1 - frames2;
    }
    ParseMTCMessage(data) {
        const frame = data[0] + data[1] * 16;
        const seconds = data[2] + data[3] * 16;
        const minutes = data[4] + data[5] * 16;
        const hours = data[6] + (data[7] & 0x01) * 16;
        const timecode = (0, types_1.newTimecode)(hours, minutes, seconds, frame, this.currentFramerate);
        return timecode;
    }
    // MMC Messages do contain the full timecode
    HandleMMCMessage(data) {
        const STOP = 0x01;
        const PLAY = 0x02;
        const PunchIn = 0x06;
        const GOTO = 0x44;
        const COMMAND = 6;
        const RESPONSE = 7;
        const CommOrRes = data[3];
        const action = data[4];
        if (action == GOTO && CommOrRes == COMMAND) {
            if (data[5] !== 6 && data[6] != 1) {
                // weird formed goto message
                return;
            }
            // extract rate from hour as they are mixed
            // 0rrhhhhh
            // rr = 00: 24 frames/s
            // rr = 01: 25 frames/s
            // rr = 10: 29.97 frames/s (SMPTE drop-frame timecode)
            // rr = 11: 30 frames/s
            let rr = (data[7] >> 5) || 24;
            // 0001 1111 = 0x1F in Hex (so we do this to remove the first 3 bits)
            const hour = data[7] & 0x1f; // masking the first 3 bits
            const minute = data[8];
            const second = data[9];
            const frame = data[10] - 32; // Protools for some reason sends 32 as the first frame
            const timecode = (0, types_1.newTimecode)(hour, minute, second, frame, rr);
            console.log("Sending MMC GOTO action", timecode);
            this.onMIDIActionCallback("GoTo", timecode);
        }
        else if (action == STOP && CommOrRes == COMMAND) {
            console.log("Sending MMC action STOP");
            let rr = (data[7] >> 5) || 24;
            // 0001 1111 = 0x1F in Hex (so we do this to remove the first 3 bits)
            const hour = data[7] & 0x1f; // masking the first 3 bits
            const minute = data[8];
            const second = data[9];
            const frame = data[10] - 32; // Protools for some reason sends 32 as the first frame
            const timecode = (0, types_1.newTimecode)(hour, minute, second, frame, rr);
            this.onMIDIActionCallback("Stop", timecode);
        }
        else {
            if (DEBUG_MIDI)
                console.log("UNKNOWN MMC MESSAGE", action, CommOrRes, data);
        }
    }
}
exports.default = MIDIReceiver;
